export default __webpack_public_path__ + "static/media/technician.231aea5d.png";